import './header.scss';
import logo from '../../assets/img/header/logo.svg';
import {Link} from 'react-router-dom';
import {ROUTES} from '../../constant/constant';

function Header() {
  return (
    <div className="Header">
      <Link to={ROUTES.HOME}><img src={logo} alt="Wi-Fi MyLotteries"/></Link>
      <div className="line">
        <div className="col1"></div>
        <div className="col2"></div>
        <div className="col3"></div>
        <div className="col4"></div>
      </div>
    </div>
  )
}

export default Header;
